import {BarcodeOutlined, EnvironmentOutlined, ShopOutlined} from '@ant-design/icons';
import {PageLayout} from '@ds/layout';
import {useNavigate} from 'react-router-dom';

import ChortkeToolCard from './components/ChortkeToolCard/ChortkeToolCard';

type ChortkeToolsProps = {
  vendorId?: string | number;
};

const ChortkeTools: React.FC<ChortkeToolsProps> = ({vendorId}) => {
  const navigate = useNavigate();

  return (
    <PageLayout contentClassName="gap-3.5 px-4 py-4.5">
      <ChortkeToolCard
        title="پرفروش‌های منطقه"
        icon={<EnvironmentOutlined aria-hidden />}
        iconTone="success"
        onClick={() =>
          navigate('/chortke/show/BSR', {
            state: {vendorId, type: 'assortment region'}
          })
        }
      />
      <ChortkeToolCard
        title="پرفروش‌های شما"
        icon={<ShopOutlined aria-hidden />}
        iconTone="primary"
        onClick={() =>
          navigate('/chortke/show/BSS', {
            state: {vendorId, type: 'assortment vendor'}
          })
        }
      />
      <ChortkeToolCard
        title="قیمت غیرمنصفانه"
        icon={<BarcodeOutlined aria-hidden />}
        iconTone="primary"
        onClick={() =>
          navigate('/chortke/unfair-price', {
            state: {vendorId, type: 'UnfairPrice'}
          })
        }
      />
    </PageLayout>
  );
};

export default ChortkeTools;
